export default __webpack_public_path__ + "412e6e63b5e453f364d6ed944ddcddbc.png";